import { useRef } from "react"
import { deleteIcon, file, fileupload } from "../../../../../constant/icons"
import { FileUpload } from "../../../type"
import { message } from "../../../../../components/toast"
import { ACCEPTS_ONLY } from "../../../message"
import { Button } from "reactstrap"

const FileAccept = ["csv", "xlsx", "xls"]
const maxSize = 50 * 1024 * 1024

const BrowserFile = (props: any) => {
    const { fileUpload, onFileUpdate, onFileUpdateRefresh } = props
    const fileInputRef: any = useRef(null)

    const onRemoveFile = () => {
        delete fileUpload[0]
        if (fileInputRef.current) {
            fileInputRef.current.value = null
        }

        onFileUpdate([])
        onFileUpdateRefresh(true)
    }

    const addFiles = (e: any) => {
        if (e?.target?.files && e.target.files.length > 0) {
            // Only process the first file if multiple are selected
            if (e.target.files.length > 1) {
                message('warning', "Only one file can be uploaded at a time.")
                if (fileInputRef.current) {
                    fileInputRef.current.value = null
                }
                return
            }

            const thisFile = e.target.files[0]
            const ext = thisFile.name.split('.').pop()?.toLowerCase()

            if (thisFile.size > maxSize) {
                message('warning', "The file exceeds the 50 MB limit.")
                if (fileInputRef.current) {
                    fileInputRef.current.value = null
                }
                return
            }

            if (ext && !FileAccept.includes(ext)) {
                message('warning', ACCEPTS_ONLY)
                if (fileInputRef.current) {
                    fileInputRef.current.value = null
                }
                return
            }

            const UploadFile: FileUpload[] = [{
                file: thisFile,
                selectedSheet: []
            }]

            onFileUpdate(UploadFile)
            onFileUpdateRefresh(true)

            console.log("UploadFile", UploadFile)

            if (fileInputRef.current) {
                fileInputRef.current.value = null
            }
        }
    }

    return (
        <div className="dropzone mb-3">
            <label htmlFor="browserfile" className="dropzone-container">
                <div className="file-icon">
                    {(!fileUpload?.length || fileUpload?.length <= 0) && fileupload.icon}
                </div>
                {(!fileUpload?.length || fileUpload?.length <= 0) && (
                    <div className="dropzone-title">
                        Drag and drop your file or
                        <span className="browse"> browse</span> your file
                    </div>
                )}
                <div className="attachment-data-list">
                    {fileUpload.length > 0 && (
                        <div className="attachment-data" key={0}>
                            <a title="File" className="file-box">
                                {file.icon}
                                <p>{fileUpload[0].file.name}</p>
                            </a>
                            <Button
                                className="remove-box"
                                title="remove"
                                onClick={(e) => {
                                    e.preventDefault()
                                    onRemoveFile()
                                }}
                            >
                                {deleteIcon.icon}
                            </Button>
                        </div>
                    )}
                </div>
            </label>

            <input
                ref={fileInputRef}
                id="browserfile"
                name="browserfile"
                type="file"
                className="form-control"
                accept=".csv,.xlsx,.xls"
                onChange={addFiles}
            />
        </div>
    )
}

export { BrowserFile }